import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Modal, Row, Table } from 'antd';
import moment from 'moment';
import TagSelect from '@comm/TagSelect/Index';
import StandardFormRow from '@comm/StandardFormRow/Index';
import { queryBudgetAnalysisIncome, queryExportBudgetAnalysisIncome } from '@api/finance/budget';
import util from '@util/index';
import '../analyze.less';
import { querySaveBooksIncome } from '@api/finance/finance';

const FormItem = Form.Item;

class TabDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordData: {
        list: [],
        pagination: {},
      },
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { year } = this.props.location.query;
    this.condition = {
      beginDate: `${year}-01-01`,
      endDate: `${year}-12-31`,
    };
    this.getAnalysisIncome();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition || {}).some(
        key => nextProps.condition[key] !== this.condition[key],
      )
    ) {
      this.condition = nextProps.condition;
      this.getAnalysisIncome();
    }
  }

  findTypeName = record => {
    let typeName = '';
    const { incomeType, expendType } = this.props;
    const type = record.target === 0 ? expendType : incomeType;
    type.forEach(item => {
      if (record.type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  exportFinanceRecord = () => {
    queryExportBudgetAnalysisIncome({
      groupUuids: this.props.params.uuid,
      target: 1,
      ...this.condition,
      ...this.searchCondition,
    });
  };

  getAnalysisIncome = () => {
    const pageSize = 10;
    queryBudgetAnalysisIncome({
      groupUuids: [this.props.params.uuid],
      limit: pageSize,
      target: 1,
      start: this.current || 1,
      ...this.condition,
      ...this.searchCondition,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.forEach(item => {
          item.typeName = this.findTypeName(item);
        });
        this.setState({
          recordData: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
        });
      }
    });
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getAnalysisIncome();
  };

  handleSearCh = () => {
    const { types = [], money = [], account = '', remark = '' } = this.props.form.getFieldsValue();
    const moneyRange = money.length > 0 ? money[0].split('~') : [];
    this.current = 1;
    this.searchCondition = {
      types,
      account,
      remark,
      begin: moneyRange[0] ? parseInt(moneyRange[0], 10) : '',
      end: moneyRange[1] || '',
    };
    this.getAnalysisIncome();
  };

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '入账公司',
        dataIndex: 'accountName',
      },
      {
        title: '收入金额',
        dataIndex: 'money',
        render: text => {
          return <span>{text > 0 ? util.numberFormat(text) : 0}</span>;
        },
      },
      {
        title: '业务类型',
        dataIndex: 'type',
        render: (text, record) => <span>{record.typeName}</span>,
      },
      {
        title: '备注',
        dataIndex: 'remark',
        width: '400px',
        render: text => <p className="banlance-remark">{text}</p>,
      },
      {
        title: '操作',
        width: '200px',
        render: (text, record) => (
          <a
            href="#"
            onClick={() => {
              Modal.confirm({
                title: '修改备注',
                content: (
                  <div className="ant-row  ant-form-item">
                    <Input.TextArea
                      className="ant-col ant-form-item-required ant-form-item-control "
                      type="text"
                      defaultValue={record.remark || ''}
                      onBlur={e => this.setState({ incomeRemark: e.target.value })}
                      rows={5}
                    />
                  </div>
                ),
                onOk: () => {
                  const { incomeRemark } = this.state;
                  querySaveBooksIncome({
                    uuid: record.uuid,
                    remark: incomeRemark,
                    type: record.type,
                  }).then(res => {
                    if (res.statusCode === 200) {
                      message.success('修改成功');
                      this.setState({ incomeRemark: '' });
                      this.getAnalysisIncome();
                    } else {
                      message.error(res.message);
                    }
                  });
                },
              });
            }}
          >
            编辑备注
          </a>
        ),
      },
    ];
  };

  setClassName = record => {
    if (record.ignore !== 0) {
      return 'td-gray';
    }
  };

  render() {
    const formItemLayout = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const { getFieldDecorator } = this.props.form;
    const actionsTextMap = {
      expandText: '展开',
      collapseText: '收起',
      selectAllText: '全部',
    };
    const {
      recordData: { list, pagination },
    } = this.state;
    const { incomeType } = this.props;
    return (
      <div className="analyze">
        <Card bordered={false} style={{ marginBottom: '16px' }}>
          <Form layout="inline">
            <StandardFormRow title="所属类目" block style={{ paddingBottom: 11 }}>
              <FormItem>
                {getFieldDecorator('types')(
                  <TagSelect expandable actionsText={actionsTextMap} multiple>
                    {incomeType.map(item => (
                      <TagSelect.Option value={item.value} key={item.key}>
                        {item.key}
                      </TagSelect.Option>
                    ))}
                  </TagSelect>,
                )}
              </FormItem>
            </StandardFormRow>
            <StandardFormRow title="金额" block style={{ paddingBottom: 11 }}>
              <FormItem>
                {getFieldDecorator('money')(
                  <TagSelect expandable={false} multiple={false} hideCheckAll>
                    <TagSelect.Option value="0">全部</TagSelect.Option>
                    <TagSelect.Option value="0~500">0~500</TagSelect.Option>
                    <TagSelect.Option value="501~1000">501~1000</TagSelect.Option>
                    <TagSelect.Option value="1001~1500">1001~1500</TagSelect.Option>
                    <TagSelect.Option value="1501~2000">1501~2000</TagSelect.Option>
                    <TagSelect.Option value="2001~5000">2001~5000</TagSelect.Option>
                    <TagSelect.Option value="5000以上">5000以上</TagSelect.Option>
                  </TagSelect>,
                )}
              </FormItem>
            </StandardFormRow>
            <StandardFormRow title="其它选项" grid last>
              <Row gutter={16}>
                <Col lg={8} md={10} sm={10} xs={24}>
                  <FormItem {...formItemLayout} label="备注">
                    {getFieldDecorator('remark', {})(<Input />)}
                  </FormItem>
                </Col>
                <Col lg={8} md={10} sm={10} xs={24}>
                  {/* <FormItem {...formItemLayout} label="对方户名">
                    {getFieldDecorator("account", {})(<Input />)}
                  </FormItem> */}
                </Col>

                <Col lg={8} md={10} sm={10} xs={24} style={{ textAlign: 'right' }}>
                  <Button type="primary" onClick={this.handleSearCh}>
                    查询
                  </Button>
                </Col>
              </Row>
            </StandardFormRow>
          </Form>
        </Card>
        <Card title="收入详情表" extra={<Button onClick={this.exportFinanceRecord}>导出</Button>}>
          <Table
            columns={this.columns()}
            dataSource={list}
            pagination={pagination}
            onChange={this.handleTableChange}
            rowClassName={this.setClassName}
            rowKey="uuid"
          />
        </Card>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(TabDetail);



// WEBPACK FOOTER //
// ./src/components/finance/budget/balance/income/TabDetail.js